exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "img[data-v-4fd72f09]{max-width:100%}", ""]);

